import {addDays, startOfDay} from 'date-fns';

type DriveSegment = {
  start: Date;
  end: Date;
};

export const splitAcrossMidnight = (start: Date, end: Date): DriveSegment[] => {
  const segments: DriveSegment[] = [];
  let segmentStart = start;

  while (startOfDay(segmentStart) < startOfDay(end) && segmentStart < end) {
    const nextMidnight = startOfDay(addDays(segmentStart, 1));
    segments.push({start: segmentStart, end: nextMidnight});
    segmentStart = nextMidnight;
  }

  const isRemainderEmpty = segmentStart >= end;
  if (!isRemainderEmpty || segments.length === 0) {
    segments.push({start: segmentStart, end});
  }

  return segments;
};
